import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import ReactTooltip from "react-tooltip";
import { Subscribe } from "unstated";
import { ScaleLoader } from "react-spinners";

import { myGlobals, myUtilities } from "../../Utils";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

class InvoiceGridRow extends React.Component {
  displayToolTip = (data, formatData) => {
    if (
      data === undefined ||
      data === null ||
      data.toString().localeCompare("null") === 0
    )
      return null;
    if (formatData.length > 8)
      return (
        <ReactTooltip
          id={"gridtooltip" + this.props.index + data}
          className="tooltip"
          place="top"
          type="dark"
          effect="solid"
        >
          <span>{this.formatDataForToolTip(formatData)}</span>
        </ReactTooltip>
      );
  };
  formatDataForToolTip = (data) => {
    let formattedData = [];
    const formatLength = 20;
    if (data.length < formatLength) return data;
    let i = 0;
    while (data.length !== 0) {
      formattedData.push(
        <React.Fragment key={i}>
          {data.substring(0, formatLength)}
          <br />
        </React.Fragment>
      );
      ++i;
      data = data.substring(formatLength, data.length);
    }
    return formattedData;
  };
  formatData = (data) => {
    if (data === undefined || data === null || data.localeCompare("null") === 0)
      return "";
    // if (data.length > 8) {
    //   return data.substring(0, 6) + "...";
    // } 
    else return data;
  };

  displayHeaders = () => {
    if (this.props.index === 0) {
      let fields = this.props.fields;
      let columns = new Array();
      if (fields !== undefined) {
        for (let i = 0; i < fields.length; ++i) {
          if (fields[i][0] !== undefined && fields[i][1] !== undefined) {
            columns.push(
              <Col key={fields[i][1]} className="row-header">
                {myUtilities.accountSpecificLanguage(
                  "invoicegrid.header.label." + fields[i][0],
                  fields[i][1],
                )}
              </Col>
            );
          }
        }
      }
      return columns;
    }
  };

  displayRow = (invoiceData) => {
    let fields = this.props.fields;
    if (fields !== undefined) {
      let columns = new Array();
      let ratio = 12 / fields.length;
      for (let i = 0; i < fields.length; ++i) {
        let fieldKey = fields[i][0];
        let data = invoiceData.validateAndPopulateInvoiceData(
          this.props.index,
          fieldKey,
          17,
          "partial"
        );
        let formattedData =
          this.formatData(myUtilities.needCurrency(fieldKey)) +
          myUtilities.toStringUtil(data, fieldKey);
        columns.push(
          <React.Fragment key={this.props.index + fieldKey}>
            {this.displayToolTip(data, formattedData)}
            <Col
              className="invoice-grid-head-col"
              data-tip
              data-for={"gridtooltip" + this.props.index + data}
              xs={ratio}
              sm={ratio}
            >
              {this.formatData(
                myUtilities.needCurrency(fields[i][0]) +
                myUtilities.toStringUtil(data, fields[i][0])
              )}
            </Col>
          </React.Fragment>
        );
      }
      return columns;
    } else
      return (
        <Col className="invoice-grid-loader-container">
          <div className="invoice-grid-loader-div">
            <ScaleLoader
              sizeUnit={"px"}
              height={17}
              color={"#000000"}
              loading={true}
            />
          </div>
        </Col>
      );
  };
  
  //Done because index starts from 0 so 0 means i.e., 1
  getEvenOrOrdd =  () =>  this.props.index % 2 === 0 ? 'grid-row-odd' : 'grid-row-even';
  
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <Row>
            <Col xs={1} sm={0}></Col>
            <Col xs={11} sm={12}>
              <Container>
                <Row>{this.displayHeaders()}</Row>
                <Row className={`grid-row-element ${this.getEvenOrOrdd()}`}>{this.displayRow(data)}</Row>
                <Row>
                  <Col>
                    <hr className="invoice-divider" width="100%" />
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        )}
      </Subscribe>
    );
  }
}

export default InvoiceGridRow;
